import { Injectable, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";

/** Product name every tab title ends with. */
export const APP_NAME = "dAIrector";

/**
 * Owns `document.title`.
 *
 * Two sources feed it: the route (module name, applied on navigation) and the
 * page itself (module name plus loaded record, applied once data arrives).
 * Page titles win while they last and fall back to the route title when cleared.
 */
@Injectable({ providedIn: "root" })
export class PageTitleService {
  private readonly title = inject(Title);

  private routeTitle = "";

  /** Route title for the page being shown. Also drops the previous page title. */
  setRouteTitle(routeTitle: string | null | undefined): void {
    this.routeTitle = this.normalize(routeTitle);
    this.render(this.routeTitle);
  }

  /** Page-supplied title, e.g. a module plus the campaign or video it's showing. */
  setContentTitle(contentTitle: string | null | undefined): void {
    this.render(this.normalize(contentTitle) || this.routeTitle);
  }

  private render(pageTitle: string): void {
    this.title.setTitle(pageTitle ? `${pageTitle} · ${APP_NAME}` : APP_NAME);
  }

  private normalize(value: unknown): string {
    return String(value ?? "")
      .replace(/\s+/g, " ")
      .trim();
  }
}
